import axiosIns from "@axios"

class ActivityLogService {
  getLogs(data) {
    return axiosIns.get('activity-logs', {
      params: data
    })
      .then(response => {
        return response.data
      })
      .catch(error => {
        if (error.response) {
          return Promise.reject(error.response.data)
        }
      })
  }

  getUsers(search = null) {
    return axiosIns.get('activity-logs/users', {
      params: { search },
    }).then(response => response.data)
  }

  getActions(search = null) {
    return axiosIns.get('activity-logs/actions', {
      params: { search },
    }).then(response => response.data)
  }
}

export default new ActivityLogService()
